import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
    const token = localStorage.getItem("accessToken"); 
  
  // If no token exists, redirect to login
  if (!token) {
    return <Navigate to="/" />;

  }

  // If token exists, render the child routes
  return <Outlet />;
};

export default PrivateRoute;
